import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=9f927330&scoped=true"
import script from "./inventoryDetails.vue?vue&type=script&lang=js"
export * from "./inventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./inventoryDetails.vue?vue&type=style&index=0&id=9f927330&prod&lang=scss&scoped=true"
import style1 from "./inventoryDetails.vue?vue&type=style&index=1&id=9f927330&prod&lang=scss&scoped=true"
import style2 from "./inventoryDetails.vue?vue&type=style&index=2&id=9f927330&prod&lang=scss&scoped=true"
import style3 from "./inventoryDetails.vue?vue&type=style&index=3&id=9f927330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f927330",
  null
  
)

export default component.exports